import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProblemModel } from 'src/app/store/problem/model';

@Component({
  selector: 'app-problem-preview',
  templateUrl: './problem-preview.component.html',
  styleUrls: ['./problem-preview.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class ProblemPreviewComponent implements OnInit {
  translate = inject(TranslateService);

  @Input() problem: ProblemModel;

  ngOnInit(): void {}
}
